interface SearchableOption {
    label?: unknown
    value?: unknown
}

export const normalizeSearchText = (value?: string | null): string =>
    value?.trim() ?? ''

export const normalizeSearchValues = (
    values?: Array<string | null | undefined> | null
): string[] =>
    Array.from(
        new Set(
            (values ?? [])
                .map((value) => normalizeSearchText(value))
            .filter(Boolean)
        )
    ).sort((left, right) => left.localeCompare(right))

export const areNormalizedSearchValuesEqual = (
    left?: Array<string | null | undefined> | null,
    right?: Array<string | null | undefined> | null
): boolean => {
    const normalizedLeft = normalizeSearchValues(left)
    const normalizedRight = normalizeSearchValues(right)
    return (
        normalizedLeft.length === normalizedRight.length &&
        normalizedLeft.every((value, index) => value === normalizedRight[index])
    )
}

export const filterSearchOptionByLabel = (
    input: string,
    option?: SearchableOption
): boolean => {
    const normalizedInput = normalizeSearchText(input).toLowerCase()
    if (!normalizedInput) {
        return true
    }

    const optionText = String(option?.label ?? option?.value ?? '')
    return normalizeSearchText(optionText)
        .toLowerCase()
        .includes(normalizedInput)
}
